import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { fuseAnimations } from "@fuse/animations";
import { ServicioCotizadoDTO } from "app/main/apps/shared/interfaces/servicio-cotizado.interface";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

@Component({
    selector: "app-dialog-cotizar-servicio",
    templateUrl: "./dialog-cotizar-servicio.component.html",
    styleUrls: ["./dialog-cotizar-servicio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DialogCotizarServicioComponent implements OnInit {
    formCotizarServicio: FormGroup;
    largoMaximo = 500;
    constructor(
        public dialogRef: MatDialogRef<DialogCotizarServicioComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: ServicioCotizadoDTO,
        private fb: FormBuilder,
        private customValidators: ValidadoresFormularioService
    ) {}

    ngOnInit(): void {
        console.log(this.data);
        this.initForm();
    }

    initForm() {
        this.formCotizarServicio = this.fb.group({
            descripcionTrabajo: [
                this.data.descripcionTrabajo
                    ? this.data.descripcionTrabajo
                    : "",
                {
                    validators: [
                        Validators.required,
                        Validators.minLength(10),
                        Validators.maxLength(this.largoMaximo),
                    ],
                },
            ],
            tiempoTrabajo: [
                this.data.tiempoTrabajo ? this.data.tiempoTrabajo : null,
                {
                    validators: [
                        Validators.required,
                        Validators.min(0),
                        Validators.max(50000000),
                        Validators.pattern(
                            this.customValidators.regexSoloNumeros
                        ),
                    ],
                },
            ],
            valor: [
                this.data.valorUF ? this.data.valorUF : null,
                {
                    validators: [
                        Validators.required,
                        Validators.min(0),
                        Validators.max(50000000),
                        Validators.pattern(
                            this.customValidators.regexSoloNumerosYPunto
                        ),
                    ],
                },
            ],
        });
    }

    get descripcionTrabajo() {
        return this.formCotizarServicio.get("descripcionTrabajo");
    }
    get tiempoTrabajo() {
        return this.formCotizarServicio.get("tiempoTrabajo");
    }
    get valor() {
        return this.formCotizarServicio.get("valor");
    }
}
